// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Incident API
 * API to get incident information
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const HandlerSeverity = {
  severityFireDrill: 'fire drill',
  severityTrivial: 'trivial',
  severityMinor: 'minor',
  severityMedium: 'medium',
  severityMajor: 'major',
  severityCritical: 'critical',
  severityUnknown: 'unknown',
} as const;
export type HandlerSeverity =
  (typeof HandlerSeverity)[keyof typeof HandlerSeverity];

export function instanceOfHandlerSeverity(value: any): boolean {
  for (const key in HandlerSeverity) {
    if (Object.prototype.hasOwnProperty.call(HandlerSeverity, key)) {
      if (HandlerSeverity[key as keyof typeof HandlerSeverity] === value) {
        return true;
      }
    }
  }
  return false;
}

export function HandlerSeverityFromJSON(json: any): HandlerSeverity {
  return HandlerSeverityFromJSONTyped(json, false);
}

export function HandlerSeverityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerSeverity {
  return json as HandlerSeverity;
}

export function HandlerSeverityToJSON(value?: HandlerSeverity | null): any {
  return value as any;
}

export function HandlerSeverityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): HandlerSeverity {
  return value as HandlerSeverity;
}
